import React from "react";
import { Link } from "react-router-dom";

function ServiceItem() {
  return (
    <>
      <div className="mb-3 mt-4">
        <div className="row d-flex justify-content-center g-4 mt-5">

          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/js.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/angluar.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/vue.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/react.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>

          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/ts.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/bt.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>

        </div>



        <div className="row d-flex justify-content-center g-4 mt-3">

          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className="mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/html.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/jqery.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/me.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/node.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/php.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 order-1 wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.5s"
          >
            <div className=" mt-4 service-mt-30 d-flex ">

              <span />
              <div className="s-icon">
                <Link to={"#"} className=" ">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/bt.png"}
                    className="mx-auto"
                    alt="images"
                  />
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>

    </>
  );
}

export default ServiceItem;
